<template>
  <div>
    <list :listTitle="$t('amazon.accounts.label')" :listLogo="definitionModule.logo" filterTitle="Filtros" :typesListAvailable="['displayList']" :loading="loadingSearch || loadingAddAccount" :total="amazonAccountsTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" @change="onChange">
      <div class="btnGroup" slot="header-actions">
        <button @click="amazonAuthenticate()" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar conta">
          <i class="icon-plus"/>
        </button>
      </div>

      <template slot="filters">
        <form-group label="Nome">
          <input class="form-input" v-model="options.shopName">
        </form-group>
      </template>

      <div class="l-col-4@md" v-for="(item, index) in amazonAccounts" :key="index">
        <account :account="item"/>
      </div>
      <div class="l-col u-textCenter" v-if="!amazonAccounts.length">
        <panel>
          Nenhuma contra foi encontrado.
        </panel>
      </div>
    </list>
    <modal-account-confirmation :account="account" v-model="modalConfirmFlag" v-on:confirm="accountConfirm"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { getAllUrlParams } from '@/helper'
  import { merge } from 'lodash'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import api from '@/api'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Account from '@/components/marketplace/amazon/Account'
  import ModalAccountConfirmation from '@/components/marketplace/amazon/ModalAccountConfirmation'

  export default {
    data: () => ({
      errors: [],
      loadingAddAccount: false,
      loadingSearch: false,
      type: 'marketplace',
      identifier: 'amazon',
      options: {
        shopName: ''
      },
      sortFields: [
        'shopName'
      ],
      account: null,
      modalConfirmFlag: false,
      selling_partner_id: null,
      spapi_oauth_code: null,
      mws_auth_token: null
    }),
    mounted () {
      this.addAccountByCodeAndPartnerId(getAllUrlParams().spapi_oauth_code, getAllUrlParams().selling_partner_id)
    },
    methods: {
      ...mapActions('amazonAccounts', [
        'fetchAccounts',
        'addAccount'
      ]),
      addAccountByCodeAndPartnerId (code, sellingPartnerId) {
        const mwsAuthToken = getAllUrlParams().mws_auth_token
        if (code !== undefined && sellingPartnerId !== undefined) {
          this.loadingAddAccount = true
          api.amazon.getAccount(code, sellingPartnerId, mwsAuthToken)
            .then(account => {
              this.loadingAddAccount = false
              this.account = account
              this.modalConfirmFlag = true
            })
            .catch(error => {
              let message = 'Falha ao adicionar a conta.'
              if (error.response.data.message) {
                message = error.response.data.message
              }
              notifier.error(message, 'Não adicionada')
              this.removeCode()
            })
            .finally(() => {
              this.loadingAddAccount = false
            })
        }
      },
      removeCode () {
        const currentUrl = window.location.href
        if (currentUrl.indexOf('?state') !== -1) {
          this.loading = true
          const url = currentUrl.replace(currentUrl.substr(currentUrl.indexOf('?'), 200), '')
          window.location.replace(`${url}`)
        } else {
          this.loading = false
        }
      },
      async amazonAuthenticate () {
        window.location.href = `https://sellercentral.amazon.com.br/apps/authorize/consent?application_id=amzn1.sellerapps.app.a0bb42e2-44b1-4e2a-9875-b62c967db329&state=beta&version=beta`
      },
      async onChange (options) {
        this.loadingSearch = true

        merge(this.options, options)

        await this.fetchAccounts({ options: this.options })

        this.loadingSearch = false
      },
      async accountConfirm () {
        this.loadingAddAccount = true
        await api.amazon.addAccount(this.account.refreshToken, this.account.partnerId, this.account.mwsAuthToken)
          .then(() => {
            notifier.success('Conta adicionada com sucesso.', 'Adicionada')
            this.fetchAccounts({ options: this.options })
              .then(() => {
                this.loadingAddAccount = false
              })
          })
          .catch(error => {
            let message = 'Falha ao adicionar a conta.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Não adicionada')
            this.loadingAddAccount = false
          })
          .finally(() => {
            this.removeCode()
            this.loadingAddAccount = false
          })
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      ...mapFields({
        amazonAccountsTotal: 'amazonAccounts.total',
        amazonAccounts: 'amazonAccounts.accounts'
      }),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType(this.type, this.identifier)
      }
    },
    components: {
      ModalAccountConfirmation,
      Loader,
      PageTitle,
      List,
      Panel,
      FormGroup,
      Account
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

    .logo
      max-height: 30px
      margin-right: 20px

      .title
        margin-top: 16px
        margin-left: 20px

      .paginator
        float: right
</style>



// WEBPACK FOOTER //
// List.vue?073a6cdc